import styled from 'styled-components';

const HeroHeading = styled.h1`
  color: currentColor;
  font-family: ${Styles.fontFamily.base};
  font-size: 3.75rem;
  line-height: 90%;
  margin: 0;
  text-align: center;
  text-transform: ${Styles.textTransform.headlines};
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  width: 100%;

  ${Styles.desktop`
    font-size: 6.25rem;
    margin-bottom: 2.5rem;
    text-align: left;
  `}

  & small {
    display: inline-block;
    font-size: 3.4375rem;
    left: -5px;
    position: relative;
    text-decoration: none;
    text-transform: lowercase;
    top: -0.7rem;
    transform: translateY(0.2em);
    vertical-align: top;

    ${Styles.desktop`
      font-size: 6rem;
      left: -9px;
      position: relative;
      top: -1.2rem;
    `}
  }
`;

export default HeroHeading;
